import React, { useEffect, useState } from "react";
import { getDocs, collection } from "firebase/firestore";
import { db } from "../../firebase";
import {
  Button,
  Modal,
  Box,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";

// New ClinicSelector Component
const ClinicSelector = ({ onSelectClinic }) => {
  const [clinics, setClinics] = useState([]);
  const [open, setOpen] = useState(false);

  // Fetch clinics from Firestore
  useEffect(() => {
    const fetchClinics = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "clinic"));
        const clinicsList = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setClinics(clinicsList);
      } catch (error) {
        console.error("Error fetching clinics:", error);
      }
    };
    fetchClinics();
  }, []);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // Handle Clinic selection and pass both name and id
  const handleItemClick = (clinic) => {
    onSelectClinic({ name: clinic.name, id: clinic.id });
    handleClose();
  };

  return (
    <>
      <Button variant="outlined" onClick={handleOpen} sx={{ mt: 2 }}>
        Select Clinic
      </Button>

      <Modal
        open={open}
        onClose={handleClose}
        sx={{
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "40%",
            bgcolor: "background.paper",
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography variant="h6" component="h2" gutterBottom>
            Select a Clinic
          </Typography>
          <List sx={{ maxHeight: 200, overflowY: "auto" }}>
            {clinics.map((clinic) => (
              <ListItem
                button
                key={clinic.id}
                onClick={() => handleItemClick(clinic)}
              >
                <ListItemText
                  primary={clinic.name}
                  secondary={clinic.location}
                />
              </ListItem>
            ))}
          </List>
        </Box>
      </Modal>
    </>
  );
};

ClinicSelector.propTypes = {
  onSelectClinic: PropTypes.func.isRequired,
};

export default ClinicSelector;
